<span *ngIf="internalSource" class="{{nbcClass}}">
  <select class="dropdown-toggle form-select {{nbcMismatch}} {{customErrorClass}} pt-1" [(ngModel)]="selected"
          name="{{name}}"
          [attr.title]="title?title:null"
          [required]="nbcRequired"
          [disabled]="nbcDisabled || !isAuthorized"
          [attr.authenticate-user]="authenticateUser"
          [attr.authenticate-command]="nbcselectdisabled"
          [attr.authenticate-disabled]="authenticateDisabled"
          (change)="optionSelected(true)">
    <!--<option *ngIf="placeHolderDisplay" [ngValue]="placeHolderValue">{{placeHolderDisplay}}</option>-->
    <option *ngFor="let opt of internalSource"
            [ngValue]="opt[value]">
      {{opt[display]}}
    </option>
  </select>
</span> 
